import { ref } from "vue";
import ChatService from "../../../../core/core/chat/ChatService";
import Util from "../../../../utils/Util";
import MindMe from "../../../facade/MindMe";
import Config from "../../../../core/core/calcule/Config";
import HashMap from "../../../core/base/HashMap";
import AiCreateMind from "./AiCreateMind";
import { postMindmapMove, postMindmapNewDir } from "../../../../common/netWork/mind_map_api";
if (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0
) {
    var { ipcRenderer } = window.require("electron");

}

class AIOrgnizeFiles {
    constructor(isElectron = true, deleagte = null) {
        this.chatService = new ChatService(isElectron, 'https://todo.mindyushu.com');
        this.messages = ref([]);
        this.loading = false;
        this.isStreaming = ref(false);
        this.isElectron = isElectron;
        this.deleagte = deleagte;
        this.mindDatas = []; //当前处理的文档列表
        this.idMap = new HashMap();
        this.colorMap = new HashMap();
        this.aiCreateMinds = [];
        this.dirs = [];
        this.mindFiles = [];
        this.toParentId = ""; //夫级ID

        this.isTestData = false;
        this.valueIndex = 0;
        this.processedCountLimit = 50
        this.initConfig()
    }

    initConfig() {//4499ee、eed205、ff6600、43a102、707070
        this.colorMap.put("4499ee".toLowerCase(), 2)
        this.colorMap.put("eed205".toLowerCase(), 0)
        this.colorMap.put("ff6600".toLowerCase(), 1)
        this.colorMap.put("43a102".toLowerCase(), 3)
        this.colorMap.put("707070".toLowerCase(), 4)
    }

    loadData() {    
    }
    
    error(message) {
        this.deleagte.showError(message)       
    }

    onChatMessage(message, isEnd) {
        // console.log("message: ", message);        
        if (!isEnd) {
            return
        }
        if (message.indexOf('[') < 0 || message.indexOf('[') < 0 || message.indexOf('[错误') > -1) {
            this.deleagte.showError("分组出错") 
            this.removeMessageView()
            return
        }
        var jsonStr = message.substring(message.indexOf('['), message.lastIndexOf(']') + 1)        
        let messageObj = JSON.parse(jsonStr);
        this.aiCreateMinds = []

        for (let index = 0; index < messageObj.length; index++) {
            const item = messageObj[index];
            if (this.idMap.containsKey(item.id)) {                
                this.aiCreateMinds.push(new AiCreateMind(item.id, item, item.isDir ? 1 : 0))
            } else if (item.isDir) {
                this.aiCreateMinds.push(new AiCreateMind(item.id, item, 0))
            }
        }
        for (let index = 0; index < this.dirs.length; index++) {
            let folder = this.dirs[index]
            let isOk = false
            for (let i = 0; i < this.aiCreateMinds.length; i++) {
                const item = this.aiCreateMinds[i];
                if (item.id == folder.id) {
                    isOk = true
                    break
                }
            }
            if (isOk) {
                continue
            }
            let item = {id: folder.id, name: folder.name, isDir: true}
            this.aiCreateMinds.push(new AiCreateMind(item.id, item, 1))
        }
        // console.log("this.aiCreateMinds: ", this.aiCreateMinds);
        this.createFolder()
    }

    createFolder() {
        let targetFolder = null
        for (let index = 0; index < this.aiCreateMinds.length; index++) {
            const folder = this.aiCreateMinds[index];
            if (folder.isDir() && !folder.isCreateOrMove()) {
                targetFolder = folder
                break
            }
        }
        let that = this;
        if (targetFolder == null) {
            setTimeout(() => {
                that.moveMind()
            }, 200);
            return
        }
        let obj = {}
        obj.parentEntityId = this.toParentId;
        obj.name = targetFolder.data.name;
        var color = 1
        // console.log("targetFolder.data.color- ", targetFolder.data.color, this.colorMap);
        
        if (targetFolder.data.color != null && this.colorMap.containsKey(targetFolder.data.color.toLowerCase())) {
            color = this.colorMap.get(targetFolder.data.color.toLowerCase())
        }
        obj.colorCode = color;
        // console.log("ai new folder obj:", obj);
        
        this.deleagte.showMessage("AI 正在创建文件夹: " + obj.name)
        if (this.isTestData) {
            setTimeout(() => {
                that.idMap.put(targetFolder.id, "test-" + Util.getCurrentTime())   
                targetFolder.status = 1
                setTimeout(() => {
                    that.createFolder()
                }, 500);    
            }, 1000);
        } else {
            postMindmapNewDir(
                obj,
                (rs) => {    
                    // console.log("create folder: ", rs);                
                    that.idMap.put(targetFolder.id, rs.entityId)   
                    targetFolder.status = 1
                    setTimeout(() => {
                        that.createFolder()
                    }, 500);    
                },
                (error) => {
                    that.deleagte.showError(error.desc);
                    that.removeMessageView()
                    that.deleagte.refreshHomeMind(that.toParentId)
                }
            );
        }
    }

    removeMessageView() {
        let that = this
        setTimeout(() => {
            that.deleagte.hideMessageView()
        }, 3000);
    }

    moveMind() {
        let targetMind = null        
        for (let index = 0; index < this.aiCreateMinds.length; index++) {
            const mindFile = this.aiCreateMinds[index];
            if (!mindFile.isDir() && !mindFile.isProcessed()) {
                targetMind = mindFile
                break
            }
        }
        let that = this;
        if (targetMind == null) {
            setTimeout(() => {
                that.deleagte.showMessage("智能分组完成")
                that.deleagte.refreshHomeMind(that.toParentId)
                that.removeMessageView()
            }, 500);
            return
        }

        var entityId = ""
        var toParentId = ""
        var parentFolder = null
        if (this.idMap.containsKey(targetMind.id)) {
            entityId = this.idMap.get(targetMind.id)
        }
        var originalData = this.findMindFileOriginalData(entityId)
        let totleMindFileCount = 0
        let movedMindFileCount = 1
        for (let index = 0; index < this.aiCreateMinds.length; index++) {
            const item = this.aiCreateMinds[index];
            if (item.isDir() && item.id == targetMind.data.pId && item.isCreateOrMove()) {
                parentFolder = item                
                if (this.idMap.containsKey(item.id)) {
                    toParentId = this.idMap.get(item.id)
                }
            }
            if (!item.isDir()) {
                totleMindFileCount += 1
                if (item.isCreateOrMove()) {
                    movedMindFileCount += 1
                }
            }
        }
        let name = originalData != null ? originalData.name : "文件"
        // console.log("移动文件信息：", entityId, " toParentId: " + toParentId, parentFolder);
        
        if (entityId == "" || toParentId == "" || parentFolder == null) {
            targetMind.status = 2
            this.deleagte.showMessage("移动文件: " + name + " 出错")
            setTimeout(() => {
                that.moveMind()
            }, 100);
            return
        }
        let obj = {};
        obj.entityId = entityId;
        obj.toParentId = toParentId;
        this.deleagte.showMessage("AI 正在移动 [" + name + "]  →  [" + parentFolder.data.name + "] " + movedMindFileCount + "/" + totleMindFileCount)

        if (this.isTestData) {
            setTimeout(() => {
                targetMind.status = 1
                setTimeout(() => {
                    that.moveMind()
                }, 1000);
            }, 1000);
        } else {
            postMindmapMove(
                obj,
                (res) => {
                    targetMind.status = 1
                    setTimeout(() => {
                        that.moveMind()
                    }, 1000);
                },
                (error) => {
                    targetMind.status = 2
                    that.deleagte.showError(error.desc);
                    that.removeMessageView()
                    that.deleagte.refreshHomeMind(that.toParentId)
                }
            );
        }
    }

    findMindFileOriginalData(id) {
        if (this.mindDatas == null) {
            return null
        }
        for (let index = 0; index < this.mindDatas.length; index++) {
            let item = this.mindDatas[index]
            if (item.id == id) {
                return item
            }
        }
        return null
    }

    sendChatMessageToAiForMindFiles(mindDatas, parentId) {
        // console.log("mindDatas->", mindDatas);
        this.idMap.clear()
        this.mindDatas = mindDatas
        this.toParentId = parentId
        var id = 0;
        this.dirs = []//isDir
        this.mindFiles = []
        this.aiCreateMinds = []
        var mindLimit = this.processedCountLimit
        var mindCount = 0 
        for (let index = 0; index < mindDatas.length; index++) {
            let item = mindDatas[index]
            if (item.parentId != parentId) {
                continue
            }
            if (item.isDir) {
                this.idMap.put(id + "", item.id)
                this.dirs.push({name:item.name, id: id})
            } else {
                this.idMap.put(id + "", item.id)
                this.mindFiles.push({name:item.name, subtitle:item.subtitle, id: id})
                mindCount += 1
            }
            if (mindCount >= mindLimit) {
                break
            }
            id += 1;
        }
        var message = ""
        if (this.mindFiles.length == 0) {
            this.deleagte.showError("没有需要分组的文件") 
            return
        } else if (this.mindFiles.length == 1) {
            this.deleagte.showError("只有一个文件无需智能分组") 
            return
        } 
        if (this.dirs.length > 0) {
            message = "已经存在分组：【"
            for (let index = 0; index < this.dirs.length; index++) {
                const item = this.dirs[index];
                var name = item.name
                if (name.length > 10) {
                    name = name.substring(0, 10)
                }
                message += "id:'" + item.id + "',name:'" + this.removeSpecialChars(name) + "';"
            }
            message += "】"
        } else {
            message = "已有分组：0个，"
        }
        message += " 所有文件：【"
        for (let index = 0; index < this.mindFiles.length; index++) {
            const item = this.mindFiles[index];
            var name = item.name
            if (name.length > 8) {
                name = name.substring(0, 8)
            }
            message += "id:'" + item.id + "',name:'" + this.removeSpecialChars(name) + "';"
            // if (message.length > 1000) {
            //     break;
            // }
        }
        message += "】"
        let tip1 = "请将以下文件列表自动分组。要求："
        let prompt1 = "1、分组需要命名并指定颜色（请注意：不要只使用红色（ff6600），优先使用蓝(4499ee)、橙(eed205)、绿(43a102)、灰(707070)，且尽量让不同分组使用不同颜色，根据语意分配颜色）。"
        let prompt2 = "2、如果某个文件内容与已有分组匹配，则放入该分组；否则新建分组(新建的分组id从10000开始)。"
        let prompt3 = "3、输出仅一个符合 JSON 规范的数组，不得包含任何解释、前言、后缀或 Markdown 代码块。"
        let prompt4 = "4、输出示例格式（注意：id 和 pId 均为字符串）：[{'id':'123', 'name':'科学', 'color':'ff6600', 'isDir':true}, {'id':'232', 'pId':'123'}]。"
        let prompt5 = "5、组对象必须包含 id、name、color、isDir: true；文件对象只包含 id 和 pId（指向所属组的 id），无需 name、isDir。"
        let prompt6 = "6、可用颜色列表：4499ee (蓝)、eed205 (橙)、ff6600 (红)、43a102 (绿)、707070 (灰)"
        let tip2 = "要分组文件列表（id 为字符串，name 为文件名）：" + message
        let chatMessage = tip1 + "\n" + prompt1 + "\n" + prompt2 + "\n" + prompt3 + "\n" + prompt4 + "\n" + prompt5 + "\n" + prompt6 + "\n" + "\n" + tip2 
        // let chatMessage = "我在整理我的思维导图文件，现在要分组我的文件，请将下方我的文件帮我分组，需要新建的分组（新建分组id不要和我给你的已有分组或文件id相同）你给取名，文件夹的颜色（目前我的系统支持颜色：4499ee、eed205、ff6600、43a102、707070）" +
        //         "如果某个文件适合已有的文件夹，就放进已经的，如果没有，就新建一个文件夹，请不要" +
        //         "返回给我直接json数据格式不要额外说明文字（不得包含任何解释、前言、后缀或Markdown代码块标记、你必须直接输出一个完全符合JSON规范的对象、严格遵循JSON格式），比如[{'id':'123', 'name':'科学', 'color':'ff6600', 'isDir': true}, {'id':'232', 'pId':'123'}]，pId文件要放入的组id，为了返回数据大小，返回json里文件的name不需要，文件isDir也不需要，文件夹一定要带isDir:true,json格式一定要正确， 方便后续代码处理和使用。\n" + "「" + message + "」";
        // console.log("chatMessage->", chatMessage);

        if (this.isTestData) {
            setTimeout(() => {
                this.onChatMessage(this.getTestData(), true)
            }, 5000);
        } else {
            this.sendMessage(chatMessage, "deepseek-v3.1", true);
        }
    }

    // 移除双引号、单引号、反斜杠、方括号
    removeSpecialChars(str) {
        // 使用正则表达式，转义特殊字符
        return str.replace(/["'\\\[\]]/g, '');
    }

    newMessageId() {
        this.messageIdPoint += 1;
        return this.messageIdPoint;
    }

    isEmpty(str) {
        return str == null || str.length == 0;
    }

    sendMessage(message, model) {
        // console.log("sendMessage-> ", this.loading);
        if (message.length > 5300) {
            this.deleagte.showError("内容超过5000字，超出限制") 
            return;
        }
        if (!message || this.loading) {
            return;
        }
        this.messages = ref([]);
        // 添加用户消息
        this.messages.value.push({
            role: 'user',
            content: message,
            timestamp: new Date(),
        });
        
        // 添加AI消息占位
        this.messages.value.push({
            role: 'assistant',
            content: '',
            timestamp: new Date(),
        });

        let that = this
        this.loading = true;
        this.isStreaming.value = true;
        MindMe.useAiAddTimes()
        Config.lastUseAITime = Util.getCurrentTime()
        if (this.isTestData) {
            setTimeout(() => {
                //test
            }, 5000);
            return;
        }
        try {
            
            this.chatService = new ChatService(this.isElectron, 'https://todo.mindyushu.com');
            this.chatService.sendMessage({
                message,
                model: model,
                userId: MindMe.getUserId(),
            },
            // 数据块回调
            (chunk) => {
                const lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content += chunk;
                that.deleagte.showMessage("Ai 正在智能划分 " + that.messages.value[lastIndex].content.length)
            },
            // 完成回调
            () => {
                const lastIndex = that.messages.value.length - 1;                
                that.onChatMessage(that.messages.value[lastIndex].content, true);
                that.loading = false;
                that.isStreaming.value = false;    
            },
            // 错误回调
            (error) => {
                var lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content += `\n[错误: ${error.message}]`;
                that.onChatMessage(that.messages.value[lastIndex].content, true);
                that.loading = false;
                that.isStreaming.value = false;
            }
            );
        } catch (error) {
            // console.error('Request error:', error);
            if (error.name !== 'AbortError') {
                const lastIndex = that.messages.value.length - 1;
                that.messages.value[lastIndex].content = '请求失败，请重试。';

                that.onChatMessage(that.messages.value[lastIndex].content, true);
            }
            that.loading = false;
            that.isStreaming.value = false;
        } finally {
            that.loading = false;
            that.isStreaming.value = false;
        }
  
    }

    clearDates() {    
    }

    getTestData() {
        return "[{\"id\": \"0\", \"name\": \"智能体\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"1\", \"name\": \"应用\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"2\", \"name\": \"学习\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"3\", \"name\": \"资料\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"4\", \"name\": \"读书记录\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"5\", \"name\": \"生活日常\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"6\", \"name\": \"学生必备\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"7\", \"name\": \"工作类\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"8\", \"name\": \"思考模型\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"9\", \"name\": \"绿色\", \"color\": \"43a102\", \"isDir\": true},{\"id\": \"10\", \"name\": \"Mind+科技\", \"color\": \"4499ee\", \"isDir\": true},{\"id\": \"12\", \"pId\": \"9\"},{\"id\": \"13\", \"pId\": \"6\"},{\"id\": \"14\", \"pId\": \"8\"},{\"id\": \"15\", \"pId\": \"8\"},{\"id\": \"16\", \"pId\": \"3\"},{\"id\": \"17\", \"pId\": \"6\"},{\"id\": \"18\", \"pId\": \"3\"},{\"id\": \"19\", \"pId\": \"3\"},{\"id\": \"20\", \"pId\": \"3\"},{\"id\": \"21\", \"pId\": \"3\"},{\"id\": \"22\", \"pId\": \"7\"},{\"id\": \"23\", \"pId\": \"3\"},{\"id\": \"24\", \"pId\": \"3\"},{\"id\": \"25\", \"pId\": \"5\"},{\"id\": \"26\", \"pId\": \"10\"},{\"id\": \"27\", \"pId\": \"8\"},{\"id\": \"28\", \"pId\": \"8\"},{\"id\": \"29\", \"pId\": \"7\"},{\"id\": \"30\", \"pId\": \"6\"},{\"id\": \"31\", \"pId\": \"2\"},{\"id\": \"32\", \"pId\": \"7\"},{\"id\": \"33\", \"pId\": \"7\"},{\"id\": \"34\", \"pId\": \"6\"},{\"id\": \"35\", \"pId\": \"7\"},{\"id\": \"36\", \"pId\": \"3\"},{\"id\": \"37\", \"pId\": \"3\"},{\"id\": \"38\", \"pId\": \"5\"},{\"id\": \"39\", \"pId\": \"4\"},{\"id\": \"40\", \"pId\": \"4\"},{\"id\": \"41\", \"pId\": \"8\"},{\"id\": \"42\", \"pId\": \"4\"},{\"id\": \"43\", \"pId\": \"3\"},{\"id\": \"44\", \"pId\": \"1\"},{\"id\": \"45\", \"pId\": \"5\"}]"
    }
}

export default new AIOrgnizeFiles()